<template>
  <div class="page-container">
    <div class="data-filter">
        <el-button size="mini" type="primary" @click="pollingSave">저장하기</el-button>
    </div>
    <div class="data-table">
        <el-form ref="" :model="form">
            <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
                <el-table-column type="index" :index="rowIndex" width="100"></el-table-column>
                <el-table-column label="라이브 뷰 폴링 시간 간격">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.liveview_polling_time" style="width:100px;"></el-input> 초
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        async getPolling () {
          console.log('GET AGENT_SETTING')

          try {
            this.loading = true

            let response = await this.$http.get('agent_setting')
            this.list = response.data

            this.loading = false
            return response
          }
          catch (e) { 
            console.error(e)
          }
        },
        rowIndex (index) {
            return index + 1
        },
        async pollingSave () {
          let params = this.list[0]
          let {status} = await this.$http.post('agent_setting', params)
          if (status === 200) {
              this.$service.$emit('alert-modal', '폴링 시간 설정이 수정되었습니다.')
          }else{
            console.log('error')
          }
        }
    },
    mounted () {
      this.getPolling()
    },
    data () {
        return {
            loading: false,
            dialog_notice: false,
            dialog_notice_option: null,
            list: [],
            form: {},
            server: {
              loading: false,
              rules: {

              },
              form: {
                liveview_polling_time: 1
              }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>